import { z } from 'my-zod'
import { commentModel } from './comment-model'

export const commentSystemView = commentModel.augment({ profileName: z.string().nullish() })
export type commentSystemView = z.infer<typeof commentSystemView>
